define('Components/CategoriesWidget/js/views/CategoriesWidgetInstanceView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'template!Components/CategoriesWidget/templates/categories',
    'InternalLinkView'
],
    function($, WidgetInstanceView, app, template, InternalLinkView){
        return WidgetInstanceView.extend({
            name: 'CategoriesWidgetInstanceView',
            getTemplate: function () {
                return template
            },
            afterRender:function(){
                InternalLinkView.initializeLinksOfView(this);
            },
        })
    }
);
